import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { APIService } from '../../api.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-select-customer',
  templateUrl: './select-customer.component.html',
  styleUrls: ['./select-customer.component.scss']
})
export class SelectCustomerComponent implements OnInit {

  //@Output() StoreID: EventEmitter<any> = new EventEmitter();
  @Input() isCust: any;
  @Input() mdlRef: any;
  @Input() custID: any;

  selected = {
    id: '', 
    name: ''
  }
  customers: any = [];
  suppliers: any = [];
  jarvisData: any = [];
  agencyData: any = [];
  compRules = {
    isB2C: false
  };
  CmnService: any;

  constructor( private apiService: APIService, private commonService: CommonService) { }

  ngOnInit(): void {
    
    if(this.custID) {
      this.selected.id = this.custID;
    }

     //Get H from IDB
     var self = this;
     let hCook = this.apiService.getIDB('H', function(data: any){
       if(data){
         let tmptblH = data;
         self.customers = tmptblH.filter((c: any) => c.C == true);
         self.suppliers = tmptblH.filter((s: any) => s.S == true);
       }
     })
     
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
      this.compRules.isB2C = this.agencyData[0].IsB2C;
    }
  }

  passBack() {

    this.mdlRef.close();
  }

  save() {
    if(!this.selected.id) {
      let alt = '';
      this.isCust ? alt = 'supplier.' : alt = 'customer.';
      this.apiService.successAlert('Please select ' + alt);
      return;
    }

    let selCust = [];
    if(this.isCust){
      selCust = this.customers.filter((a: any) => a.Cmp == this.selected.id );
    } else {
      selCust = this.suppliers.filter((a: any) => a.Cmp == this.selected.id );
    }
    
    this.mdlRef.close(selCust);
  }

  checkValidCust() {
    let chk = [];
    if(this.isCust){ 
      chk = this.customers.filter((a: any) => a.Cmp == this.selected.id );
    } else {
      chk = this.suppliers.filter((a: any) => a.Cmp == this.selected.id );
    }

    if(chk.length == 0) {
      this.selected.id = '';
    }
  }

}
